(ns rothko.editor.word.component
  (:require [reagent.core :as r]
            [rothko.editor.mark.core :as mark]))

(defn token
  [_]
  (let [!internal-state (r/atom {:hover? false})]
    (fn [{:keys [!state appearance] {:keys [marks word edited? tagged? ignored? different? misspelled? system? suspicious?]} :token}]
      [:span.editor__spellcheck
       {:class (when (and misspelled?
                       (not (or edited? tagged?))) :misspelled)}
       [:span.editor__word
        {:class (cond-> appearance

                  (or edited? tagged?)
                  (conj :edited)

                  (:hover? @!internal-state)
                  (conj :hover)

                  ignored? (conj :ignored)

                  different? (conj :different)

                  (and edited? system?) (conj :system-annotation)

                  (and system?
                       (= (:implementation @!state)
                          :script-annotator)) (conj :system-annotation)

                  (and suspicious?
                       (not (and edited? system?))) (conj :suspicious)

                  marks
                  (clojure.set/union (mark/->appearances marks)))
         :on-mouse-enter #(swap! !internal-state assoc :hover? true)
         :on-mouse-leave #(swap! !internal-state assoc :hover? false)}
        word]])))
